import React from 'react';
import { Appbar, Surface, useTheme } from 'react-native-paper';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { CompleteDriverProfileForm } from '../../src/components/CompleteDriverProfileForm';

export default function CompleteDriverProfile() {
  const { t } = useTranslation();
  const theme = useTheme();
  const router = useRouter();

  return (
    <Surface style={{ flex: 1, backgroundColor: theme.colors.background }}>
      <Appbar.Header>
        <Appbar.BackAction onPress={() => router.back()} />
        <Appbar.Content title={t('completeDriverProfile.title', 'Completar Perfil de Motorista')} />
      </Appbar.Header>
      <CompleteDriverProfileForm onSuccess={() => router.replace('/dashboard/home')} />
    </Surface>
  );
}
